export default __webpack_public_path__ + "static/media/maker.8ec54fca.svg";